import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";

const { carbon } = colorsPalettes;

export const SubtitleText = styled.span`
    ${setFontVariant("input2", carbon[500])};
`;
export const BoldSubtitleText = styled.span`
    ${setFontVariant("subtitle2", carbon[500])};
`;
